import { render, staticRenderFns } from "./LoginPageEmail.vue?vue&type=template&id=5a9a8aae&"
import script from "./LoginPageEmail.vue?vue&type=script&lang=js&"
export * from "./LoginPageEmail.vue?vue&type=script&lang=js&"
import style0 from "./LoginPageEmail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports